export type ISidebarConfig = {
	route: string | { default: string; RBDM?: string };
	ariaLabel: string | { default: string; TSI?: string; IMR?: string };
	icon: string;
	key: string;
};

export const SidebarConfig: ISidebarConfig[] = [
	{
		key: 'dashboard',
		route: '/',
		ariaLabel: 'Dashboard',
		icon: 'icon-dashboard-menu-2',
	},
	{
		key: 'members',
		route: '/end-users',
		ariaLabel: 'Members',
		icon: 'icon-member-module',
	},
	{
		key: 'one-to-many-meeting',
		route: '/meetings',
		ariaLabel: 'One to Many Meet',
		icon: 'icon-one-to-meny',
	},
	{
		key: 'one-to-one-meeting',
		route: '/one-to-one-meeting',
		ariaLabel: 'One to One Meet',
		icon: 'icon-users',
	},
	{
		key: 'calendar',
		route: '/calendar',
		ariaLabel: 'Calendarization',
		icon: 'icon-calendar-2',
	},
	{
		key: 'dfcc-clubs',
		route: '/dfcc-clubs',
		ariaLabel: 'DFCC Clubs',
		icon: 'icon-site-info',
	},
	{
		key: 'site-leads',
		route: '/sites',
		ariaLabel: 'Site Leads',
		icon: 'icon-below-ground',
	},
	{
		key: 'prospective-site-leads',
		route: '/prospective-site',
		ariaLabel: 'Prospective Site Leads',
		icon: 'icon-mdp',
	},
	{
		key: 'case-module',
		route: '/case-module',
		ariaLabel: 'Case Details',
		icon: 'icon-case-details',
	},
	{
		key: 'pcms',
		route: '/pcms',
		ariaLabel: 'PCMS',
		icon: 'icon-pcms',
	},
	{
		key: 'feedback-questionnaires',
		route: '/feedback-questionnaires',
		ariaLabel: 'Feedback Questionnaires',
		icon: 'icon-feedback-ques',
	},
	{
		key: 'user-transfer',
		route: '/user-transfer/request',
		ariaLabel: 'User Transfer',
		icon: 'icon-transfer',
	},
	{
		key: 'jharokha',
		route: '/jharokha',
		ariaLabel: 'Jharokha',
		icon: 'icon-tv',
	},
];
